"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconNoCredit = void 0;

var React = __importStar(require("react"));

exports.IconNoCredit = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 47.5",
    version: "1.1",
    x: "0px",
    y: "0px"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-6.000000, -5.000000)",
    fillRule: "nonzero",
    fill: color
  }, React.createElement("path", {
    d: "M11.5225899,15 L8,15 L8,33 L25.4086715,33 L11.5225899,15 Z M12.5056639,13 L29.4775414,35 L8,35 C6.8954305,35 6,34.1045695 6,33 L6,15 C6,13.8954305 6.8954305,13 8,13 L12.5056639,13 Z M20.3634916,15 L34.2495732,33 L40,33 L40,15 L20.3634916,15 Z M16.2946218,13 L40,13 C41.1045695,13 42,13.8954305 42,15 L42,33 C42,34.1045695 41.1045695,35 40,35 L33.2664993,35 L16.2946218,13 Z M22,19 L40,19 L40,22 L24,22 L22,19 Z M7.33001059,19 L16,19 L18,22 L7.33001059,22 L7.33001059,19 Z M11.2082256,6.61081358 L12.7917744,5.38918642 L40.7948993,41.3923113 L39.2113504,42.6139385 L11.2082256,6.61081358 Z"
  }))));
});